import styled, { css } from "styled-components";
import { theme as lexusTheme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

const WIDTH = 50;
const WIDTH_MOBILE = 30;
const MARGIN = 12;
const ARROW_OFFSET = 50;
const RING_OFFSET = 4;
export const TOTAL_WIDTH = WIDTH + MARGIN * 3;

type ExteriorImageType = {
    image?: string;
    rgb?: string;
    isSelected?: boolean;
    zoomedIn: boolean;
    lightColour: boolean;
};

export const ExteriorImage = styled.div<ExteriorImageType>`
    position: relative;
    top: 0;
    width: ${WIDTH_MOBILE}px;
    height: ${WIDTH_MOBILE}px;
    margin: 0 ${MARGIN}px;
    background-color: transparent;
    border-radius: 50%;
    ${({ image, zoomedIn }) =>
        image &&
        css`
            background-image: url(${image});
            background-position: center;
            background-size: ${!zoomedIn ? "100%" : "55px"};
        `};
    ${({ rgb, image }) =>
        rgb &&
        !image &&
        css`
            background-color: ${`#${rgb.substr(0, 2) === "0x" ? rgb.substr(2) : rgb}`};
        `};

    &::before {
        position: absolute;
        top: -${RING_OFFSET}px;
        left: -${RING_OFFSET}px;
        width: calc(100% + ${RING_OFFSET * 2}px);
        height: calc(100% + ${RING_OFFSET * 2}px);
        content: "";
        border: 1px solid transparent;
        border-color: ${({ isSelected }) => (isSelected ? lexusTheme.colors.steel : "transparent")};
        border-radius: 50%;
        transition: border-color 0.3s;
    }
    @media ${getBreakpoint("up", "md")} {
        width: ${WIDTH}px;
        height: ${WIDTH}px;
    }
`;

export const ItemWrapper = styled.button<{ showDivider?: boolean }>`
    ${({ showDivider }) =>
        showDivider &&
        css`
            position: relative;
            margin-left: ${lexusTheme.space[3] / 2}px;
            padding-left: ${lexusTheme.space[3] / 2}px;
            &::before {
                display: block;
                position: absolute;
                top: calc(50% - ${WIDTH_MOBILE / 2}px);
                left: 0px;
                width: 1px;
                height: ${WIDTH_MOBILE}px;
                content: "";
                background-color: ${lexusTheme.colors.platinumLight};
                box-sizing: border-box;

                @media ${getBreakpoint("up", "md")} {
                    top: calc(50% - ${WIDTH / 2}px);
                    height: ${WIDTH}px;
                }
            }

            html[dir="rtl"] & {
                margin-left: 0;
                margin-right: ${lexusTheme.space[3] / 2}px;
                padding-left: 0;
                padding-right: ${lexusTheme.space[3] / 2}px;
                &::before {
                    left: auto;
                    right: 0px;
                }
            }
        `};
`;

export const Wrapper = styled.div`
    position: relative;
    left: -${MARGIN / 2}px;

    html[dir="rtl"] & {
        left: auto;
        right: -${MARGIN / 2}px;
    }
`;

export const Slider = styled.div`
    flex: 1;
    overflow: hidden;
    user-select: none;
`;

export const SliderViewport = styled.div<{ rightArrowVisible?: boolean }>`
    display: flex;
    position: relative;
    align-items: center;
    width: 100%;
    height: 50px;
    overflow: hidden;

    @media ${getBreakpoint("up", "md")} {
        height: 70px;
    }

    @media ${getBreakpoint("up", "lg")} {
        width: calc(100% - ${({ rightArrowVisible }) => (rightArrowVisible ? ARROW_OFFSET : 0)}px);
    }
`;

export const Track = styled.div<{ width?: number; enableTransition?: boolean }>`
    display: flex;
    position: absolute;
    top: 0px; /* This might seem like a unnecessary property, but our friend IE11 thinks this is very important */
    flex-direction: row;
    align-items: center;
    width: ${({ width }) => (width !== undefined ? `${width}px` : "initial")};
    height: 100%;
    ${({ enableTransition }) =>
        enableTransition &&
        css`
            transition:
                left 0.5s,
                right 0.5s;
        `};
`;

export const SliderButton = styled.button<{ alignment: string; show?: boolean }>`
    position: absolute;
    top: calc(50% - ${WIDTH / 2}px);
    width: ${WIDTH}px;
    height: ${WIDTH}px;
    margin: 0;
    padding: 0;
    background-color: transparent;
    border: 0;
    z-index: 20;
    ${({ show }) =>
        !show &&
        css`
            visibility: hidden;
        `};

    ${({ alignment }) =>
        alignment === "left"
            ? css`
                  left: -35px;
              `
            : css`
                  right: 0;
              `};

    html[dir="rtl"] & {
        ${({ alignment }) =>
            alignment === "left"
                ? css`
                      left: 0;
                  `
                : css`
                      right: -${ARROW_OFFSET}px;
                  `};
    }

    @media ${getBreakpoint("down", "lg")} {
        display: none;
    }
`;
